import Box from '@mui/material/Box'

import { RISK, SEVERITY, SOURCE_STATUS, STAGE_STATUS } from '../labels'
import { FONT_MONO, RISK_COLOR, SEVERITY_COLOR, STATUS_COLOR } from '../theme'

type Kind = 'source' | 'stage' | 'risk' | 'severity'

const MAPS: Record<Kind, [Record<string, string>, Record<string, string>]> = {
  source: [SOURCE_STATUS, STATUS_COLOR],
  stage: [STAGE_STATUS, STATUS_COLOR],
  risk: [RISK, RISK_COLOR],
  severity: [SEVERITY, SEVERITY_COLOR],
}

const STAGE_COLOR: Record<string, string> = {
  not_started: '#A6998A',
  in_progress: '#3091B5',
  done: '#3F8F5B',
  late: '#DF412A',
  at_risk: '#DE8A1B',
  blocked: '#C0221A',
}

interface Props {
  value: string
  kind?: Kind
}

/**
 * Calcomanía de estado: punto + palabra.
 *
 * El punto no es adorno — duplica la información del color en forma y posición,
 * que es lo único que sigue funcionando cuando alguien no distingue el ámbar
 * del rojo o cuando el tablero se imprime en blanco y negro.
 */
export function StatusChip({ value, kind = 'source' }: Props) {
  const [labels, colors] = MAPS[kind]
  const color = (kind === 'stage' ? STAGE_COLOR[value] : colors[value]) ?? '#A6998A'

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.75,
        bgcolor: `${color}14`,
        color,
        border: `1px solid ${color}38`,
        borderRadius: 999,
        pl: 0.9,
        pr: 1.15,
        height: 24,
        fontFamily: FONT_MONO,
        fontSize: '0.6875rem',
        fontWeight: 500,
        letterSpacing: '0.03em',
        whiteSpace: 'nowrap',
      }}
    >
      <Box
        component="span"
        sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: color, flexShrink: 0 }}
      />
      {labels[value] ?? value}
    </Box>
  )
}
